import { createRef, useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { MapContainer, Polygon, GeoJSON, useMap } from 'react-leaflet';
import { latLng, latLngBounds } from 'leaflet';
import { MapService, getAuthToken } from '../../service';

const countryStyle = {
    color: 'black',
    weight: 0.3,
    opacity: 1
};

const MapLeaflet = ({ zoneData }) => {
    const { instance, accounts } = useMsal();
    const [isLoading, setIsLoading] = useState(true);

    const [mapCenter, setMapCenter] = useState({ lat: 25, lng: 0 });
    const [mapZoom, setMapZoom] = useState(2.2);

    const corner1 = createRef(latLng(-90, -200));
    const corner2 = createRef(latLng(90, 200));
    const bounds = createRef(latLngBounds(corner1.current, corner2.current));

    const [countryFeature, setCountryFeature] = useState();

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            const authToken = await getAuthToken(instance, accounts);
            const countryData = await MapService.getCountryDataPoints(authToken);

            if (!countryData) {
                alert('NO DATA');
            }
            setCountryFeature(countryData);
            setIsLoading(false);
        })();
    }, []);

    const onEachCountry = (country, layer) => {
        const mapData = countryFeature; // CountryJson.features;

        if (mapData && mapData.length > 0) {
            const found = mapData.find((x) => x.countryCode === country.properties.iso_3166_1_alpha_2_codes);
            if (found) {
                layer.options.fillOpacity = 1;
                layer.options.fillColor = '#f5f5f5';
                layer.options.interactive = false;
            }
        }
    };

    return (
        <>
            {isLoading ? (
                <>Loading...</>
            ) : (
                <MapContainer
                    whenCreated={(map) => {
                        map.createPane('labels');
                        map.getPane('labels').style.zIndex = 650;
                        var labelLayer = L.tileLayer('https://{s}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}.png', { noWrap: true, pane: 'labels' });
                        map.addLayer(labelLayer);
                    }}
                    style={{ height: '100%', width: '100%', backgroundColor: '#bdbdbd' }}
                    center={mapCenter}
                    zoom={mapZoom}
                    scrollWheelZoom={true}
                    maxBounds={bounds.current}
                    maxBoundsViscosity={2.0}
                    zoomControl={false}
                    zoomSnap={1}
                    maxZoom={20}
                    minZoom={2.2}
                >
                    <>
                        {zoneData.map((zone, index) => (
                            <Polygon positions={zone} options={{ strokeWeight: 2, strokeOpacity: 0.8, strokeColor: '#621AE5', fillOpacity: 0.1, fillColor: '#8148EA' }} />
                        ))}

                        <GeoJSON style={countryStyle} data={countryFeature} onEachFeature={onEachCountry} />
                    </>
                </MapContainer>
            )}
        </>
    );
};

export default MapLeaflet;
